import PropTypes from 'prop-types';
import React from 'react';
import { POST_CODE_MAX_LENGTH } from '../../brands/default/constants';
import { LOOKUP_ADDRESS_COMP } from '../../brands/default/content/components/address';
import ButtonForm from '../_generic/button/CTAButton';
import FormikInput from '../_generic/input/FormikInput';

const LookupAddress = ({
  onChangeFunction,
  onBlurFunction,
  values,
  errors,
  touched,
  lookupAddress,
  extraClasses = '',
  lookupAddressText = '',
  disabled = false,
}) => {
  const setInputField = (event) => {
    if (event.target.value.length > POST_CODE_MAX_LENGTH) {
      event.target.value = event.target.value.slice(0, POST_CODE_MAX_LENGTH);
    }
    onChangeFunction(event);
  };

  return (
    <>
      <div className="col-12 col-md-6">
        <FormikInput
          dataqa="postCode"
          disabled={disabled}
          errorText={errors.postCode}
          extraClasses={extraClasses}
          inputError={errors.postCode}
          inputTouched={touched.postCode}
          inputValue={values.postCode}
          maxLength={POST_CODE_MAX_LENGTH}
          name={'postCode'}
          onBlurFunction={onBlurFunction}
          onChangeFunction={setInputField}
          placeholder={
            lookupAddressText
              ? lookupAddressText
              : LOOKUP_ADDRESS_COMP.registrationAddress
          }
          type="text"
        />
      </div>
      <div className="col-12 col-md-6">
        <ButtonForm
          className="full-width address-button"
          dataqa="lookupAddress"
          disabled={Boolean(!values.postCode || errors.postCode || disabled)}
          onClick={lookupAddress}
        >
          {LOOKUP_ADDRESS_COMP.lookupAddress}
        </ButtonForm>
      </div>
    </>
  );
};

LookupAddress.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.object.isRequired,
  extraClasses: PropTypes.string,
  lookupAddress: PropTypes.func.isRequired,
  lookupAddressText: PropTypes.string,
  onBlurFunction: PropTypes.func.isRequired,
  onChangeFunction: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};

export default LookupAddress;
